import React from 'react'
import { Header } from '../Core/Header'
import { useEffect } from 'react'
import { fetchingOutlate } from '../Services/Operations/ProductAPI'
import { useState } from 'react'
import { Footer } from '../Core/Footer'

const Store = () => {
    const [store,setStore]=useState([])


    const fetchOutlates=async()=>{
      
      try {
        const response=await  fetchingOutlate()
        console.log(response[0]);

        if(response.length!==0){
            console.log("list of store data.....",response);
            
            setStore(response) 
            return
        }
       
        
      } catch (error) {
        console.log(error);
        
      }
    }

useEffect(() => {
  fetchOutlates()
}, [])




  return (
    <div>
         <Header/>
         <div className='w-full h-[100vh] flex items-center justify-center flex-col'>

            this is stores
            {store.map((str,index)=>(
                <div>
                    {str.storeName}
                    <p>{str.storeAddress}</p>
                </div>
            ))}
            
         </div>
         <Footer/>

    </div>
  )
}

export default Store